import { HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiErrorTrackerService } from '@app/shared/services/api-error-tracker.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { isExcludedEndpoint } from '@shared/utils/endpoint-exclusion/endpoint-exclusion.util'

export class GlobalErrorInterceptor implements HttpInterceptor {
  private errorTracker = inject(ApiErrorTrackerService);
  private router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // skip explict endpoints
    if (isExcludedEndpoint(req.url)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.errorTracker.recordSuccess();
        }
      }),
      catchError((error: HttpErrorResponse) => {

        if (error.status >= 500) {
          const reachedLimit = this.errorTracker.recordFailure();

          if (reachedLimit) {
            this.errorTracker.recordSuccess();
            this.router.navigate(['/system-maintenance']);
          }
        }

        return throwError(() => error);
      })
    );
  }
}

